import {ERROR_CODES, RESPONSE_ERROR_CODES_MAP} from '../DNFORM-utils/DNFORM-constants';

export const responseHandlerMixin = {
	data() {
		return {
			ERROR_CODES
		};
	},
	methods: {
		getFirstStepWithError(responseData) {
			let result = this.currentStep;

			if (this.isLastStep) {
				result = Number(Object.keys(responseData)[0]);
			}

			return result;
		},
		setResponseErrors(responseErrors) {
			const validationErrors = {};

			responseErrors.forEach(responseError => {
				if (responseError && responseError.errors && Array.isArray(responseError.errors)) {
					responseError.errors.forEach(error => {
						const errorCode = RESPONSE_ERROR_CODES_MAP[error] || ERROR_CODES.UNKNOWN;
						validationErrors[responseError.field] = errorCode;
					});
				}
			});

			this.errors.setError(validationErrors);
		},
		getResponseErrors(responseData) {
			let results = [];

			if (this.isLastStep) {
				results = responseData[Object.keys(responseData)[0]];
			} else {
				results = responseData[this.currentStep];
			}

			return results;
		},
		handleErrorResponse(responseData) {
			const firstStepWithError = this.getFirstStepWithError(responseData);
			this.changeStep(firstStepWithError);

			const responseErrors = this.getResponseErrors(responseData);
			this.setResponseErrors(responseErrors);

			this.$nextTick(() => {
				this.scrollToFirstInvalidInput();
			});
		},
		handleSendFormResponse(response) {
			this.resetSubmitFailed();

			if (response.data.status && response.data.status === 'OK') {
				this.isSubmitSuccessful = true;
				this.removeSessionFromCookie();
			} else {
				const hasErrors = !!Object.keys(response.data).length;

				if (hasErrors) {
					this.handleErrorResponse(response.data);
				}
			}
		},
		handleSendTemporaryFormResponse({data}) {
			this.resetSubmitFailed();

			// https://wiki.shiwaforce.com/pages/viewpage.action?pageId=115281886
			if (data.status && data.status === 'OK' || (!data[this.currentStep] || !data[this.currentStep].length)) {
				this.addStepToDoneSteps(this.currentStep);
				this.changeStep(this.currentStep + 1);
			} else if (data[this.currentStep] && data[this.currentStep].length) {
				this.handleErrorResponse(data);
			}
		}
	}
};



// WEBPACK FOOTER //
// ../source/modules/DNFORM/DNFORM-mixins/DNFORM-response-handler-mixin.js